import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import { NavItem } from 'react-bootstrap';
import InnerPage from './QuickSearchInnerPage';
import { fetchAllFilters } from '../../FilterActions';
import ProgressBar from '../../../../components/progress-bar';

class QuickSearchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      errors: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.setState({ loading: true, loaded: false, errors: null });
    this.props.dispatch(fetchAllFilters())
      .then(
        () => {
          this.setState({ loading: false, loaded: true });
        },
        (errors) => {
          this.setState({
            loading: false, loaded: false, errors: errors.data?.message || errors,
          });
        },
      );
  }
  
  renderInstruction() {
  
    return (
      <div className="well">
        <p>
          The following field types can be used to as quick search: <code>picklist</code>, <code>multipicklist</code>, <code>string</code> and fields.
        </p>
        <p>
          Select the field(s) you want the quick search to perform matching opportunity/account records
        </p>
      </div>
    );
  }

  render() {
    const { location: { pathname } } = this.props;
    const { loading } = this.state;
    const comps = [
      {
        uri: 'opportunities',
        source: 'opportunity',
        label: 'Opportunity Search',
      },
      {
        uri: 'accounts',
        source: 'account',
        label: 'Account Search',
      }
    ];
    return (
      <div className="container">
        <Helmet title="Quick Search" />
        {this.renderInstruction()}
        <p />
        {loading && <ProgressBar />}
        {!loading && 
          <div>
            {comps.length > 1 &&
              <div>
                <ul className="nav nav-tabs">
                  {comps.map(comp => (
                    <LinkContainer key={comp.uri} to={`/setup/quick-search/${comp.uri}`}>
                      <NavItem>{comp.label}</NavItem>
                    </LinkContainer>
                  ))}
                </ul>
                <p />
              </div>
            }
            {comps.length > 0 && pathname === '/setup/quick-search' && <Redirect to={`/setup/quick-search/${comps[0].uri}`} />}
          </div>
        }
        <div>
          {!loading && 
            <div>
              <Switch>
                {comps.map((comp) => {
                  return (
                    <Route
                      key={comp.uri}
                      path={`/setup/quick-search/${comp.uri}`}
                      render={(props) => {
                        return (<InnerPage source={comp.source} {...props} />);
                      }}
                    />
                  );
                })}
              </Switch>
            </div>
          }
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

QuickSearchPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.shape({}).isRequired,
};

QuickSearchPage.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
};


export default withRouter(connect(mapStateToProps)(QuickSearchPage));
